module.exports = __webpack_public_path__ + "static/media/Downstream.bf62b004.png";